(function ($) {
    $(function () {
        $('.delete-attachment').click(function () {
            var $item = $(this).closest('.ajax-item');
            $item.fadeOut(500);
        });
    });


    $(function () {
        $('.global-attachment-delete').unbind('click');
        $('.global-attachment-delete').click(function () {
            var item = $(this).parents('div.global-attachment');
            var attachmentId = item.find('.global_attachment_id').val().toString();
            var deletedList = $('#deleted_attachment_ids').val().toString();
            var newList = "";
            if (deletedList) {
                newList = deletedList.concat(',', attachmentId);
            } else {
                newList = attachmentId;
            }
            $('#deleted_attachment_ids').val(newList);
            item.hide();
        });
    })

})(jQuery);
